<template>
    <div>
      <div class="p404 bg-cercles">
        <div class="p404__content">
          <img
            class="p404__favicon"
            src="../assets/img/logos/favicon.svg"
            alt=""
          />
          <h2 class="p404__title">Error de servidor</h2>
          <h4 class="p404__subtitle">
            Parece que algo no ha funcionado como es debido. Disculpa las molestias.
          </h4>
        </div>
      </div>
    </div>
</template>
  
<script>
export default {
  name: "Error",
  metaInfo() {
    return {
      title: "Algo ha ido mal | HelloBB",
      meta: [
         { name: "description", content: "Lo sentimos. Ha habido un error."},
         { name: "robots", content: "noindex"}
      ],
    };
  },
};
</script>
